function init(){
  if (document.querySelector('.play-btn')) {
    document.querySelector('.play-btn').addEventListener('click', (e) => {
      // @ts-ignore
      e.target.classList.toggle('hidden');
      const video = document.querySelector('.video-file video');
      // @ts-ignore
      video.play();
      // @ts-ignore
      video.controls = true;
    });
  }
}

export default function VideoPlayer() {
  init();
}
